var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"ampcontent",staticClass:"amap-container",attrs:{"id":_vm.penID}})
}
var staticRenderFns = []

export { render, staticRenderFns }